import { useSyncExternalStore } from 'react'
import { CollectionState } from '../../../lib'

export function useSelectedFieldToUpdate (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('selectedFieldToUpdateChanged', callback),
    () => state.selectedFieldToUpdate
  )
}
